import { makeStyles } from "@material-ui/core";

export const usePulse = makeStyles({
  "@keyframes pulseAnimate": {
    "0%": {
      opacity: 0,
    },
    "30%": {
      opacity: 0.25,
    },
    "100%": {
      opacity: 0,
    },
  },
  pulse: {
    "&:before": {
      content: "'' !important",
      background: "black !important",
      position: "absolute !important",
      left: "0px !important",
      top: "0px !important",
      width: "100% !important",
      height: "100% !important",
      borderRadius: "4px !important",
      animation: "$pulseAnimate 4s infinite !important",
      mixBlendMode: "hard-light !important",
      pointerEvents: "none !important",
      zIndex: "-1 !important",
    },
  },
  pulseSplitView: {
    background: "black",
    animation: "$pulseAnimate 4s infinite",
  },
});
